import { Slot } from '@radix-ui/react-slot';
import { cn, cva } from '@thinkalpha/ui-core/utils';
import type { VariantProps } from '@thinkalpha/ui-core/utils';
import { forwardRef } from 'react';

const widgetHeaderIconButtonVariants = cva(
    'group/WidgetHeaderIconButton flex size-6 cursor-pointer items-center justify-center rounded-xs',
    {
        variants: {
            variant: {
                hover: 'transition-colors hover:bg-gray-700',
                'no-hover': '',
            },
        },
        defaultVariants: {
            variant: 'hover',
        },
    },
);

export type WidgetHeaderIconButtonVariants = VariantProps<typeof widgetHeaderIconButtonVariants>;

interface WidgetHeaderIconButtonProps
    extends React.ButtonHTMLAttributes<HTMLDivElement>, WidgetHeaderIconButtonVariants {
    asChild?: boolean;
}

export const WidgetHeaderIconButton = forwardRef<HTMLDivElement, WidgetHeaderIconButtonProps>(
    ({ children, className, variant = 'hover', asChild, ...props }, ref) => {
        const Comp = asChild ? Slot : 'div';
        return (
            <Comp
                role="button"
                ref={ref}
                className={cn(widgetHeaderIconButtonVariants({ variant }), className)}
                {...props}
            >
                {children}
            </Comp>
        );
    },
);

WidgetHeaderIconButton.displayName = 'WidgetHeaderIconButton';
